export enum UserRoles {
    SuperAdmin = "Super Admin"
}
